import { createGenericDispatcher } from '../../action/action-dispatcher-factory';
import { employeeSelector, employeesStateForIdSelector } from '../../reducers/employee-selectors';
import { shouldStatusExecute } from '../../reducers/utils/state-manager';

import * as Api from '../../api/api';

export const loadEmployee = (
  employeeId: number,
  notFoundHandler?: (args: { [key: string]: any }) => void,
) =>
  createGenericDispatcher<Employee>({
    name: 'LOAD_EMPLOYEE',
    loadFunction: () => Api.get(`/employee/${employeeId}`),
    args: { employeeId },
    shouldExecute: (state) => {
      const status = employeesStateForIdSelector(state, employeeId);
      const employeeIsLoaded = Boolean(employeeSelector(state, employeeId));
      return shouldStatusExecute(status, employeeIsLoaded);
    },
    notFoundHandler,
  });
